export class FSxRestoreDestination {
    'region';
    'fileSystemName';
    'subnetIds';
    'securityGroupIds';
    'encryptionKey';
    'storageCapacity';
    'throughputCapacityMBps';
    'tags';
    'ontapRestoreOptions';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "fileSystemName",
            "baseName": "fileSystemName",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetIds",
            "baseName": "subnetIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "securityGroupIds",
            "baseName": "securityGroupIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "encryptionKey",
            "baseName": "encryptionKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "storageCapacity",
            "baseName": "storageCapacity",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "throughputCapacityMBps",
            "baseName": "throughputCapacityMBps",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "ontapRestoreOptions",
            "baseName": "ontapRestoreOptions",
            "type": "FSxRestoreDestinationOntapRestoreOptions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FSxRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
